import type { WeekType, WorkScheduleDayEntry } from '@functieloonhuis/shared';

export const DAY_LABELS: Record<number, string> = {
  1: 'Ma',
  2: 'Di',
  3: 'Wo',
  4: 'Do',
  5: 'Vr',
  6: 'Za',
  7: 'Zo',
};

/**
 * De dagen die elk weekoverzicht en elk dagfilter toont: ma t/m vr.
 *
 * De labels hierboven houden 6 en 7 (zaterdag/zondag) — `ScheduleForm`
 * biedt die nog steeds aan, en bestaande data kan ze bevatten. Alleen de
 * OVERZICHTEN tonen ze niet meer (besluit Friso 2026-07-29).
 */
export const WORKWEEK_DAYS = [1, 2, 3, 4, 5] as const;

/**
 * Is dit ISO-dagnummer (1 = maandag .. 7 = zondag) een werkdag?
 *
 * Voor overzichten die al dag-entries van de server krijgen en dus niet met
 * `Date`-objecten filteren (zie `isWerkdag` in `dateUtils` voor die kant).
 */
export function isWerkdagNummer(dayOfWeek: number): boolean {
  return dayOfWeek >= 1 && dayOfWeek <= 5;
}

export const DAY_LABELS_FULL: Record<number, string> = {
  1: 'Maandag',
  2: 'Dinsdag',
  3: 'Woensdag',
  4: 'Donderdag',
  5: 'Vrijdag',
  6: 'Zaterdag',
  7: 'Zondag',
};

export function getDayEntryForDay(
  entries: WorkScheduleDayEntry[],
  dayOfWeek: number
): WorkScheduleDayEntry | undefined {
  return entries.find(e => e.dayOfWeek === dayOfWeek);
}

export function hasWeekData(entries: WorkScheduleDayEntry[]): boolean {
  return entries.length > 0;
}

export function getAriaLabel(entry: WorkScheduleDayEntry | undefined, dayOfWeek: number): string {
  const dayName = DAY_LABELS_FULL[dayOfWeek] ?? `Dag ${dayOfWeek}`;

  if (!entry || !entry.isWorkday) {
    return `${dayName}: vrij`;
  }

  const parts = [dayName];
  parts.push(entry.location === 'kantoor' ? 'kantoor' : 'thuis');

  if (entry.isHalfDay && entry.halfDayPeriod) {
    parts.push(`halve dag (${entry.halfDayPeriod})`);
  }

  if (entry.startTime && entry.endTime) {
    parts.push(`${entry.startTime}-${entry.endTime}`);
  }

  return parts.join(', ');
}

export function getDefaultWeek(currentWeekType: WeekType | undefined, hasWeekB: boolean): WeekType {
  if (!hasWeekB) return 'A';
  return currentWeekType ?? 'A';
}
